<template>
	<v-app class="auth-layout-wrapper">

		<v-alert
			v-if='isShowAlert'
			absolute
			:type="alertType || 'success'"
			transition="scale-transition"
			class='app-alert'
			:dismissible='false'
		>
			{{alertMessage}}

			<v-icon
				style="font-size: 20px;"
				@click="closeAlert"
			>mdi-window-close</v-icon>

		</v-alert>

		<AppTopBar
			v-bind:menuList="menuList"
		/>

		<v-main class="v-main_container">
			<v-container
				:fluid="shouldBeFullWidth"
				:class="shouldBeFullWidth ? '' : 'auth-container'"
			>
				<ChatNotification
					v-if="notifications.length > 0 && shouldShowNotification"
					:showChatNotification="showChatNotification"
					:notifications="notifications"
					@closeChatNotification="handleClose"
				/>
				<PostReportNotification :showNotification.sync="showNotification" />
				<v-row>
					<v-col
						v-if="shouldShowSidebar"
						:md="leftSideBarMd"
						sm="12"
						class="pt-0 hidden-md-and-down"
					>
						<AppSidebar
							:menuListHandler="menuListHandler"
						/>
					</v-col>
					<v-col
						:md="12"
						class="pt-0 pb-0"
						:lg="contentWidthLg"
						:class="shouldBeFullWidth ? 'pa-0' : ''"
					>
						<slot></slot>
					</v-col>
					<v-col
						v-if="shouldRightBannerShow && !shouldBeFullWidth"
						:md="12"
						class="pt-0 pb-0 hidden-md-and-down"
						:lg="shouldRightBannerShow && 3"
						:class="shouldRightBannerShow ? 'pa-0' : ''"
					>
						<AdBanner
							v-if='shouldShowSidebar'
						/>
					</v-col>
				</v-row>
			</v-container>
		</v-main>
	</v-app>
</template>
<script>
import { isUndefined } from 'lodash'
import AppSidebar from '@/components/Layouts/parts/AppSidebar'
import AppTopBar from '@/components/Layouts/parts/AppTopBar'
import ChatNotification from '@/components/Notifications/ChatNotification'
import PostReportNotification from '@/components/Notifications/PostReportNotification'
import { mapActions, mapGetters } from 'vuex'
import AdBanner from '@/components/Layouts/parts/AdBanner.vue'

export default {
	components: {
		AdBanner,
		AppTopBar,
		AppSidebar,
		ChatNotification,
		PostReportNotification,
	},
	data: () => ({
		navCategory: null,
		showNotification: false,
		showChatNotification: false,
		accentColor: '#9b1045',
		menuList: [],
		notifications: [],
	}),
	watch: {
		isAuthenticated(val, oldVal) {
			if (isUndefined(oldVal)) return
			if (!val) this.$router.replace('/auth')
		},
	},
	methods: {
		...mapActions('app', ['hideAlert']),

		closeAlert() {
			clearTimeout(this.closeTimeout);
			this.hideAlert()
		},

		handleClose() {
			this.notifications = []
			this.showChatNotification = false
		},
		menuListHandler(menu) {
			this.menuList = menu
		}
	},
	computed: {
		...mapGetters('auth', ['profile']),
		...mapGetters('settings', ['web']),
		...mapGetters('app', ['isShowAlert', 'alertMessage', 'closeTimeout', 'alertType']),

		user() {
			return this.profile
		},
		shouldShowNotification() {
			return this.$route.name !== 'chat' && this.$route.name !== 'chats'
		},
		shouldShowSidebar() {
			return this.$route.meta.sidebar
		},
		shouldBeFullWidth() {
			return this.$route.meta.fullWidth
		},
		shouldRightBannerShow() {
			if (!this.web) {
				return false
			}
			return !!this.web.banner_image
		},
		leftSideBarMd() {
			return this.shouldRightBannerShow ? 3 : 4;
		},
		contentWidthLg() {
			if (this.shouldShowSidebar && this.shouldRightBannerShow) {
				return 6;
			}

			if (this.shouldShowSidebar && !this.shouldRightBannerShow) {
				return 8;
			}

			return 12;
		},
	},
	destroyed() {
		this.$eventBus.$off('show-report-notification')

		if (this.user) {
			window.Echo.leave('App.User.' + this.profile.id)
		}
	},
}
</script>

<style lang="scss">
.auth-container {
	max-width: 1284px !important;
}
.v-main_container {
	background: #f1f1f1;
}
@media screen and (max-width: 1400px) {
	.auth-container {
		max-width: 1284px !important;
	}
}
.app-alert {
	top: 20px;
	right: 20px;
	position: fixed;
	z-index: 2;
}
.fade-enter-active, .fade-leave-active {
	transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to {
	opacity: 0;
}
</style>
